

const ValuerAmendMultiSelectButton = (props) => {

    const selected = props.selected;
    const label = props.label;
    const identifier = props.identifier;
    const inline = props.inline;
    const updateFunction = props.updateFunction

    return (
        <div className={"valuer-amend-multi-select-button-container" + (inline ? ' inline' : '')}
             onClick={() => updateFunction(identifier, !selected)}>
            <div className="valuer-amend-multi-select-button-circle">
                {selected && selected
                    ? <div className="valuer-amend-multi-select-button-circle-inner"/>
                    : null
                }
            </div>
            <div className="valuer-amend-multi-select-button-text">
                {label && label}
            </div>
        </div>
    )
}

export default ValuerAmendMultiSelectButton;